export const institutionNameWithLineBreaks = (value?: string | null): string => {
  if (!value) return ''

  const name = value.replace(/\r\n?/g, '\n')
  if (!/<\/?br(?:\s[^>]*)?>/i.test(name)) return name

  const document = new DOMParser().parseFromString(name.replace(/<\/br\s*>/gi, ''), 'text/html')
  document.body.querySelectorAll('br').forEach((breakElement) => breakElement.replaceWith('\n'))
  return document.body.textContent || ''
}

export const institutionNameOnOneLine = (value?: string | null): string =>
  institutionNameWithLineBreaks(value).replace(/\s+/g, ' ').trim()
